/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import "intl-tel-input/build/css/intlTelInput.css";
import IntlTelInput from "intl-tel-input/react";
import { useCountry } from "../../context/country";

const IntlTelInputBoxWithEmail = ({
  setFullPhone,
  selectedPhone,
  handleIntel,
  inputType,
  setInputType,
  setEditNumber,
  setNumber,
  number,
}) => {
  const [country] = useCountry();
  const [isValid, setIsValid] = useState(false);
  //const [inputType, setInputType] = useState("blank"); // default blank
  const [currentCountry, setCurrentCountry] = useState("");
  const blankInputRef = useRef(null);
  const emailInputRef = useRef(null);

  const isEmail = (val) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val?.trim());

  const handleNumberChange = (val) => {
    const trimmedVal = val?.trim() || "";

    setNumber(trimmedVal || "");
    setFullPhone(trimmedVal || "");

    //console.log(trimmedVal);

    const onlyPlusAndDigits = /^[+\d]+$/.test(trimmedVal);
    const hasSpecialCharExceptPlus = /[^a-zA-Z0-9+]/.test(trimmedVal);
    const hasLetters = /[a-zA-Z]/.test(trimmedVal);

    if (trimmedVal === "") {
      //console.log("object"); //return false;
      setInputType("blank");
      setIsValid(false);
      handleIntel(false);
      setEditNumber(false);
    } else if (hasLetters || hasSpecialCharExceptPlus) {
      // It's email if it has letters or any special char except +
      setInputType("email");
      setIsValid(false);
      handleIntel(false);
      if (isEmail(trimmedVal)) {
        setEditNumber(true);
      } else {
        setEditNumber(false);
      }
    } else if (onlyPlusAndDigits) {
      // It's a valid phone number format (validation handled by plugin)
      setInputType("phone");
    } else {
      // fallback
      setInputType("email");
      setIsValid(false);
      handleIntel(false);
      if (isEmail(trimmedVal)) {
        setEditNumber(true);
      } else {
        setEditNumber(false);
      }
    }
  };

  const handlePhoneValidity = (valid) => {
    if (inputType === "phone") {
      setIsValid(valid);
      handleIntel(valid);
    }
  };

  useEffect(() => {
    if (inputType === "phone") {
      setTimeout(() => {
        const el = document.querySelector(".iti__tel-input");
        if (el) {
          el.focus();
          console.log("Focused on phone input");
        } else {
          console.warn("Phone input not found");
        }
      }, 100);
    }

    if (inputType === "email") {
      emailInputRef.current?.focus();
    }
    if (inputType === "blank") {
      blankInputRef.current?.focus();
    }
  }, [inputType]);

  return (
    <>
      {inputType === "blank" && (
        <div
          className={`intel-box ${
            number === "" ? "" : isValid ? "valid-intel" : "not-valid-itel"
          }`}
        >
          <input
            key="email"
            type="text"
            className="not-a-no"
            placeholder="Enter Email / Mobile number"
            value={number}
            onChange={(e) => handleNumberChange(e.target.value)}
            ref={blankInputRef}
          />
        </div>
      )}

      {inputType === "email" && (
        <div
          className={`intel-box ${
            number === "" ? "" : isValid ? "valid-intel" : "not-valid-itel"
          }`}
        >
          <input
            key="email"
            type="text"
            className="not-a-no"
            placeholder="Enter Email / Mobile number"
            value={number}
            onChange={(e) => handleNumberChange(e.target.value)}
            ref={emailInputRef}
          />
        </div>
      )}

      {inputType === "phone" && (
        <div
          className={`intel-box ${
            number === "" ? "" : isValid ? "valid-intel" : "not-valid-itel"
          }`}
        >
          <IntlTelInput
            key="phone"
            inputProps={{
              className: "",
              disabled: isValid, // disables if valid
              inputMode: "numeric",
              pattern: "[0-9]*",
              onKeyDown: (e) => {
                const allowedKeys = [
                  "Backspace",
                  "Delete",
                  "ArrowLeft",
                  "ArrowRight",
                  "Tab",
                ];
                if (!/^\d$/.test(e.key) && !allowedKeys.includes(e.key)) {
                  e.preventDefault();
                }
              },
            }}
            initialValue={selectedPhone || number}
            onChangeCountry={setCurrentCountry}
            onChangeNumber={handleNumberChange}
            onChangeValidity={handlePhoneValidity}
            initOptions={{
              initialCountry: country?.country_code || "in",
              showSelectedDialCode: true,
              showFlags: true,
              allowDropdown: true,
              formatOnDisplay: false,
              nationalMode: false,
              utilsScript: "/js/utils.js",
              autoPlaceholder: "polite",
              customPlaceholder: () => "Enter Mobile Number",
            }}
          />
        </div>
      )}
    </>
  );
};

export default IntlTelInputBoxWithEmail;
